import { render } from "./InsufficientFunds.vue?vue&type=template&id=25170b06"
import script from "./InsufficientFunds.vue?vue&type=script&lang=js"
export * from "./InsufficientFunds.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__